// actions.js
import * as actionTypes from "../../actionLabels/index";
  
  export const fetchBidHistoryRequest = (data) => ({
    type: actionTypes.FETCH_BID_HISTORY_REQUEST,
    payload: data,
  });
  
  export const fetchBidHistorySuccess = (data) => ({
    type: actionTypes.FETCH_BID_HISTORY_SUCCESS,
    payload: data,
  });
  
  export const fetchBidHistoryFailure = (error) => ({
    type: actionTypes.FETCH_BID_HISTORY_FAILURE,
    payload: error,
  });
  
  export const viewBidHistoryRequest = (lotNo) => ({
    type: actionTypes.VIEW_BID_HISTORY_REQUEST,
    payload: lotNo,
  });
  
  export const viewBidHistorySuccess = (data) => ({
    type: actionTypes.VIEW_BID_HISTORY_SUCCESS,
    payload: data,
  });
  
  export const viewBidHistoryFailure = (error) => ({
    type: actionTypes.VIEW_BID_HISTORY_FAILURE,
    payload: error,
  });

export const fetchBidHistoryDropdownRequest = (id) => ({
    type: actionTypes.FETCH_BID_HISTORY_DROPDOWN_REQUEST,
    payload: id,
});

export const fetchBidHistoryDropdownSuccess = (data) => ({
    type: actionTypes.FETCH_BID_HISTORY_DROPDOWN_SUCCESS,
    payload: data,
});

export const fetchBidHistoryDropdownFailure = (error) => ({
    type: actionTypes.FETCH_BID_HISTORY_DROPDOWN_FAILURE,
    payload: error,
});
export const bidHistoryExport = (data) => ({
  type: actionTypes.BID_HISTORY_EXPORT,
  payload: data,
});